import { FC } from "react"

import { TOOLBAR_BLOCKS } from "./helpers/blockRegistry"
import { PromotionBlockType } from "./types/types"

type Props = {
  onAddBlock: (type: PromotionBlockType) => void
}

export const BlocksToolbar: FC<Props> = ({ onAddBlock }) => {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <span className="text-sm opacity-70">Add block:</span>

      {TOOLBAR_BLOCKS.map((def) => (
        <button key={def.type} type="button" className="btn btn-xs btn-primary odd:btn-secondary" onClick={() => onAddBlock(def.type)}>
          {def.label}
        </button>
      ))}
    </div>
  )
}
